<template>
  <DialogFull :data="dialogSettings" @close="close">
    <div class="container col-lg-8 col-sm-12">
      <ContactDetails @close="close" submitButtonTitle="Save Changes" />
    </div>
  </DialogFull>
</template>

<script>
import DialogFull from "@/components/common/DialogFull";
import ContactDetails from "@/views/profile/QuestionsAndAnswers/steps/ContactDetails/ContactDetails";

export default {
  name: "EditContactDetailsDialog",
  components: {
    DialogFull,
    ContactDetails
  },
  props: {
    isOpen: Boolean
  },
  computed: {
    dialogSettings() {
      return {
        dialog: this.isOpen,
        title: "Contact Details"
      };
    }
  },
  methods: {
    close() {
      this.$emit("close");
    }
  }
};
</script>

<style lang="scss"></style>
